
import React, { Component } from 'react';
import {TreeSelect, message, Input, Modal, Icon, Spin, Select} from 'antd';
import '../../../static/css/index.css'
import { addUser, fetchUser, getOrg } from '../../../apis/api'
import debounce from 'lodash/debounce';

const TreeNode = TreeSelect.TreeNode;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const { Option } = Select;

class AddUser extends Component {
  constructor(props) {
    super(props);
    this.fetchUser = debounce(this.fetchUser, 1000);
    this.state={
        access_token:'',
        user_options:[],
        fetching:false,
        user_uuid:'',
        username:'',
        name:'',
        user:undefined,
        mobile:'',
        treeData: [],//组织架构数据
        childTreeData: [],//从父级获取组织架构数据
        loading:false,
        search_orgName:'',
        orgValue:[],//指定当前选中的组织架构
        scope:'',//用户权限json字符串
        scope_before_list:[],//之前已选择的权限范围
    }
  }

  componentDidMount(){
    this.setState({access_token:sessionStorage.getItem('access_token')},()=>{
        this.getOrgApi(0);
    })
    // if(this.props.visible){
    //     this.getOrgApi(0);
    // }
  }

  
  componentWillReceiveProps(nextProps) { 

    // if(nextProps.visible){
    //     this.getOrgApi(0);
    // }

  }

  fetchUser = value => {
    let _this=this;
    const { access_token } = this.state;
    let params={
        access_token:access_token,
        keyword:value,
        page:1,
        page_size:50
    }

    if(value){
    this.setState({ user_options: [], fetching: true });
    fetchUser(params).then( (data)=> {
  
        if(data.code === 0){

            // if(data.content.list&&data.content.list.length){
                let user_options=data.content.list;
                _this.setState({ user_options, fetching: false });
            // }

        }else{

            message.error(data.message); 
        }
    });
    }else{
        this.setState({ user_options: [] });
    }
  }

  changeMobile= (value, option) => {

      this.setState({user:option})

  };

    //搜索组织架构
    getOrgApi(parentOrg_uuid){
        var _this=this;
        var params={
          access_token:_this.state.access_token,
          parent_uuid:parentOrg_uuid,
          page:1,
          page_size:9999
        }
        getOrg(params).then(res => {
        
          // console.log(res);
          if(res.code == 0){
            if(parentOrg_uuid==0){
               _this.setState({treeData:res.content.list})
            }else{
              _this.setState({childTreeData:res.content.list})
            }
          }else{
            message.error(res.message);
          }
    
        })
      }

    //改变用户权限---取消选中时有bug
    changeUserPrivilege = (value, label, extra) => {
        // console.log(value)
        // console.log(extra)
        var arr=this.state.scope_before_list;
        var str='';
        let obj=extra.triggerNode.props.dataRef;
        arr.push({"uuid":obj.uuid,"name":obj.name,"org_type":obj.org_type,"corp_id":obj.corp_id});
        str=JSON.stringify(arr)
        this.setState({scope:str,scope_before_list:arr,orgValue:value});
      }
  
      //一级一级获取组织架构，传入父级orgUuid
    onLoadData = TreeNode2 =>{
      let _this=this;
      return new Promise(resolve => {
        if (TreeNode2.props.children) {
          resolve();
          return;
        }
        getOrg({
          access_token:_this.state.access_token,
          parent_uuid:TreeNode2.props.dataRef.uuid,
          corp_id:TreeNode2.props.dataRef.corp_id,
          page:1,
          page_size:9999
        }).then(function(data) {
         if (data.code === 0) {
          TreeNode2.props.dataRef.children=data.content.list;
           _this.setState({
            treeData: [..._this.state.treeData],
           });
           resolve();
         }else {
           message.error(data.message);
         }
       })
      });
      }
  
    // TreeSelect树型选择控件
    renderTreeNodes = data => data&&data.map((item) => {
      if (item.children&&item.children.length) {
        return (
          <TreeNode title={item.name} key={item.uuid} value={item.uuid} type={item.org_type} corp_id={item.corp_id} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={item.name} key={item.uuid} value={item.uuid} type={item.org_type} corp_id={item.corp_id} dataRef={item}/>;
    })
  
    onSearch = (e) => {
      let _this=this;
      let value=e.target.value;
      _this.setState({search_orgName:value})
    }

    //搜索组织架构
    onPressEnter= (flag,e) => {
      let _this=this;
      let value=_this.state.search_orgName;
      _this.setState({treeData:[],loading:false},()=>{
        var e = document.createEvent("MouseEvents");
        e.initEvent("click", true, true);
        if(flag=='range'){
            document.querySelector('#range .ant-select-selection').dispatchEvent(e); 
        }else if(flag=='range2'){
            document.querySelector('#range2 .ant-select-selection').dispatchEvent(e); 
        }
        if(value){
          getOrg({
            access_token:_this.state.access_token,
            key:value,
            page:1,
            page_size:9999
          }).then(function(data) {
            if (data.code == 0) {
              _this.setState({ treeData: data.content.list,loading:true});
            } else {
              message.error(data.message);
            }
          })
         }else{
            _this.getOrgApi(0);
         }
        
      })
    }

  // 点击取消按钮
  handleCancel = (e) => {
    this.props.cancelModal();//关闭弹窗
    this.setState({
        user_uuid:'',
        username:'',
        mobile:'',
        name:'',
        user:undefined,
        user_options:[],
        treeData: [],
        childTreeData: [],
        loading:false,
        search_orgName:'',
        orgValue:[],
        scope_before_list:[],
        scope:''
    })//清空数据
  }

  // 点击确定按钮
  handleOk = (e) => {
    let _this=this,user_arr=[];
    const { access_token, scope, user } = _this.state;
    if(user&&user.length){
        user.map(item=>{
            let obj={
                user_uuid:item.key,
                name:item.props.name,
                username:item.props.username,
                mobile:item.props.mobile,
            }
            user_arr.push(obj);
        })
        let params={
            access_token:access_token,
            role_uuid:_this.props.role_uuid,
            user_json:JSON.stringify(user_arr),
            scope:scope
        }
        addUser(params).then( (data)=> {
            if(data.code===0){
                message.success('按员工授权成功！');
                _this.handleCancel();
                _this.props.getRoleUserList();//更新列表
            }else{
                
                message.error(data.message);
    
            }
        });
    }else{
        
        message.warning('请选择员工！');
 
     }
    
  }

  render() {
   
    let _this=this;
    const { visible, role_name } = this.props;
    const { fetching, loading, search_orgName, orgValue, user_options } = this.state;

    const antIcon = <Icon type="loading" style={{ color: '#108ee9'}} spin/>;
    return (

       <div className='addUser_form'>

        <Modal
          title='按员工授权'
          visible={visible}
          maskClosable={false}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="确定"
          cancelText="取消"
        >

           <div style={{marginLeft:30}}>
              <div style={{display:'flex',marginBottom:20}}>
                  <p style={{paddingTop:5,width:100}}>角色名称：</p>
                  <div style={{width:300,marginRight:20}}> <Input value={role_name} disabled/></div>
              </div>
              <div style={{display:'flex',marginBottom:20}}>
                  <p style={{paddingTop:5,width:100}}>员工：</p>
                  <div style={{width:300,marginRight:20}}> 
                    <Select mode="multiple" labelInValue value={this.state.user} style={{width:'100%'}} allowClear showSearch optionFilterProp='children' placeholder='请输入手机号码/oa账号/姓名' notFoundContent={fetching ? <Spin size="small" /> : null} onSearch={this.fetchUser} onChange={this.changeMobile} filterOption={false}>
                           {user_options&&user_options.length&&user_options.map(opt=>{
                               return(
                               <Option key={opt.uuid} username={opt.username} mobile={opt.mobile} name={opt.name}>{opt.name}-{opt.username}-{opt.org_name}-{opt.job_type}</Option>
                               )
                           })}
                    </Select>
                  </div>
              </div>

              <div style={{display:'flex',marginBottom:20}}>
               <p style={{paddingTop:5,width:100}}>员工权限：</p>
               <div style={{paddingTop:5, width:300, position:'relative', display:'inline-block'}} id="range"> 
                <Input.Search placeholder="请输入组织名称" value={search_orgName} onChange={this.onSearch.bind(this)} onSearch={this.onPressEnter.bind(this,'range')}/>
                <TreeSelect
                     showSearch={false}
                     value={orgValue}
                     onChange={this.changeUserPrivilege.bind(this)}
                     loadData={this.onLoadData.bind(this)}
                     treeCheckable={true}
                     showCheckedStrategy={SHOW_PARENT}
                     treeCheckStrictly={true}
                     searchPlaceholder='请选择组织架构'
                     style={{width:300,marginTop:5}} 
                     dropdownStyle={{height:300}}
                     getPopupContainer={() => document.getElementById('range')}
                >
                   {loading||(!loading&&this.state.treeData&&this.state.treeData.length)?(this.renderTreeNodes(this.state.treeData)):(<TreeNode title={<Spin indicator={antIcon} size='small'/>} />)}
                </TreeSelect>
               </div>
              </div>
           </div>

        </Modal>
             
       </div>
    );
  }
}

export default AddUser;



// WEBPACK FOOTER //
// ./src/page/Privilege/components/addUser.js